import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef02fa6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "study-material-detail-right-box"
};
const _hoisted_2 = {
  class: "hot-section"
};
const _hoisted_3 = {
  class: "section-header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "热门资料", -1));
const _hoisted_5 = {
  class: "hot-list"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "hot-count"
};
const _hoisted_8 = {
  key: 0,
  class: "empty-hot"
};
const _hoisted_9 = {
  class: "contact-section"
};
const _hoisted_10 = {
  class: "section-header"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "欢迎咨询", -1));
const _hoisted_12 = {
  class: "contact-content"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "contact-text"
}, "📚 关注公众号，咨询学习资料相关内容", -1));
const _hoisted_14 = {
  class: "qr-wrapper"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "contact-tip"
}, "微信扫码即可关注我们", -1));
const _hoisted_17 = {
  class: "tip-section"
};
const _hoisted_18 = {
  class: "section-header"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "购买须知", -1));
const _hoisted_20 = {
  class: "tip-list"
};
const _hoisted_21 = ["src"];
import { CheckCircleOutlined, FireOutlined, InfoCircleOutlined, WechatOutlined } from '@ant-design/icons-vue';
import image_scroll from '../../../assets/scroll.png';
import { useScroll } from "@vueuse/core";
import { onMounted, onUnmounted, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialDetailRight',
  props: {
    materialTopFiveList: {}
  },
  setup(__props) {
    const {
      y
    } = useScroll(window);
    const toTopFun = () => {
      let timer = setInterval(function () {
        const osTop = document.documentElement.scrollTop || document.body.scrollTop;
        const iSpeed = Math.floor(-osTop / 7);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + iSpeed;
        if (osTop === 0) {
          clearInterval(timer);
          timer = null;
        }
      }, 30);
    };
    const props = __props;
    const getRankClass = index => {
      if (index === 0) return 'rank-gold';
      if (index === 1) return 'rank-silver';
      if (index === 2) return 'rank-bronze';
      return 'rank-normal';
    };
    const formatCount = count => {
      if (!count) return '0';
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + '万';
      }
      return count.toString();
    };
    const isMobile = ref(false);
    const checkIfMobile = () => {
      isMobile.value = window.innerWidth <= 768;
    };
    onMounted(() => {
      checkIfMobile();
      window.addEventListener('resize', checkIfMobile);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkIfMobile);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(FireOutlined), {
        class: "section-icon"
      }), _hoisted_4]), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialTopFiveList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "hot-item"
        }, [_createElementVNode("span", {
          class: _normalizeClass(["rank-badge", getRankClass(index)])
        }, _toDisplayString(index + 1), 3), _createElementVNode("a", {
          href: '/business/studyMaterial/detail/' + item.id,
          target: "_blank",
          class: "hot-link"
        }, _toDisplayString(item.name), 9, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(formatCount(item.viewCount)) + "浏览", 1)]);
      }), 128)), !_ctx.materialTopFiveList.length ? (_openBlock(), _createElementBlock("li", _hoisted_8, " 暂无热门数据 ")) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(WechatOutlined), {
        class: "section-icon wechat-icon"
      }), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
        class: "qr-image",
        src: require('../../../assets/ai-niuzhanAccount.jpg'),
        alt: "公众号二维码"
      }, null, 8, _hoisted_15)]), _hoisted_16])]), _createElementVNode("section", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_unref(InfoCircleOutlined), {
        class: "section-icon info-icon"
      }), _hoisted_19]), _createElementVNode("ul", _hoisted_20, [_createElementVNode("li", null, [_createVNode(_unref(CheckCircleOutlined), {
        class: "tip-icon"
      }), _createTextVNode(" 资料为虚拟商品，下单后进入我的订单页面支付即可获取")]), _createElementVNode("li", null, [_createVNode(_unref(CheckCircleOutlined), {
        class: "tip-icon"
      }), _createTextVNode(" 若是免费资料，点击立即后进入我的订单页面即可获取")]), _createElementVNode("li", null, [_createVNode(_unref(CheckCircleOutlined), {
        class: "tip-icon"
      }), _createTextVNode(" 支持支付宝在线支付")]), _createElementVNode("li", null, [_createVNode(_unref(CheckCircleOutlined), {
        class: "tip-icon"
      }), _createTextVNode(" 如有问题可联系在线客服")]), _createElementVNode("li", null, [_createVNode(_unref(CheckCircleOutlined), {
        class: "tip-icon"
      }), _createTextVNode(" 资料持续更新，欢迎收藏")])])]), !isMobile.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(y) > 600 ? 'toTop hidden' : 'toTop goTop hidden'),
        onClick: toTopFun
      }, [_createElementVNode("img", {
        src: _unref(image_scroll),
        alt: ""
      }, null, 8, _hoisted_21)], 2)) : _createCommentVNode("", true)]);
    };
  }
});